/**
 * ================================================================
 * LOADING SPINNER - Unified Loading Component
 * ================================================================
 *
 * Component spinner thống nhất cho toàn bộ ứng dụng
 * Thiết kế dựa trên spinner chuyên nghiệp từ ProfileGuard
 *
 * Features:
 * - Spinner màu vàng với animation mượt mà
 * - Text tùy chỉnh
 * - Kích thước linh hoạt
 * - Background tùy chọn
 *
 * @author MeBi Team
 * @version 1.0.0
 */

import React from "react";
import { Spinner } from "@mebi/ui";

interface LoadingSpinnerProps {
  text?: string;
  message?: string; // Alias for text for backward compatibility
  size?: "sm" | "md" | "lg";
  showBackground?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  text = "Đang tải...",
  message,
  size = "md",
  showBackground = true,
  className = "",
}) => {
  // Use message if provided, otherwise use text
  const displayText = message || text;
  const textSizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
  };

  const containerClass = showBackground
    ? "min-h-screen w-full flex items-center justify-center bg-Color-Background-neutral-default_primary"
    : "flex items-center justify-center";

  return (
    <div className={`${containerClass} ${className}`}>
      <div className="text-center">
        <Spinner size={size} variant="primary" className="mx-auto mb-4" />
        <p
          className={`text-Color-Text-neutral-secondary ${textSizeClasses[size]}`}
        >
          {displayText}
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
